import { Component } from '@angular/core';
import { AppComponent } from './app.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent {
    userName:string;
    constructor(public app: AppComponent, private router: Router) {
        let uname = localStorage.getItem('user_name');
        if(uname){
            this.userName= uname.replace('"','').replace('"','');
        }
        else{
            this.userName='Guest'
        }
    }

    themeChange(e) {
        const themeLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('theme-css');
        const href = themeLink.href;
        const themeFile = href.substring(href.lastIndexOf('/') + 1, href.lastIndexOf('.'));
        const themeTokens = themeFile.split('-');
        const themeName = themeTokens[1];
        const themeMode = themeTokens[2];
        const newThemeMode = (themeMode === 'dark') ? 'light' : 'dark';

        this.app.changeTheme(themeName + '-' + newThemeMode);
    }

    logout(){
       // localStorage.removeItem('member-id');
        //localStorage.removeItem('user_name');
        localStorage.clear();
        this.router.navigate(['/']);
    }
}



// WEBPACK FOOTER //
// ./src/app/app.topbar.component.ts